var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-secondary', {
          attrs: {
            "itemTitle": "청약신청",
            "bg": "/images/form/application/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("청약신청")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6",
      "order-lg": "2"
    }
  }, [_c('v-card', {
    staticClass: "pa-24px px-md-40px py-md-84px",
    attrs: {
      "tile": ""
    }
  }, [_c('tit-wrap', {
    staticClass: "tit-wrap--sm"
  }, [_c('tit-wrap', {
    staticClass: "tit-wrap--xs"
  }, [_c('tit', {
    staticClass: "font-secondary primary--text"
  }, [_vm._v("The Podium 830")])], 1), _c('tit', [_vm._v("더포디엄830 청약신청 접수/조회")])], 1), _c('tit-wrap', {
    staticClass: "tit-wrap--sm"
  }, [_vm.isBeforeOpen ? _c('div', {
    staticClass: "tit"
  }, [_vm._v("청약신청 시작전입니다.")]) : !_vm.isDead ? _c('v-row', {
    staticClass: "row--xs"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "white--text v-btn--width-fixed",
    attrs: {
      "tile": "",
      "x-large": "",
      "color": "black"
    },
    on: {
      "click": _vm.open
    }
  }, [_c('span', {
    staticClass: "font-size-14 font-size-lg-16"
  }, [_vm._v("청약신청/조회")])])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--width-fixed",
    attrs: {
      "tile": "",
      "x-large": "",
      "color": "primary",
      "to": "/subscription/recruitment"
    }
  }, [_c('span', {
    staticClass: "font-size-14 font-size-lg-16"
  }, [_vm._v("모집공고 다운로드")])])], 1)], 1) : _c('div', {
    staticClass: "tit"
  }, [_vm._v("청약신청 기간이 아닙니다.")])], 1), _c('sheet-primary', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--xxs"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('txt', {
    staticClass: "font-weight-bold txt--dark"
  }, [_vm._v("주택위치")])], 1), _c('v-col', [_c('txt', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" 서울특별시 광진구 자양동 8-8외 3필지 "), _c('br'), _vm._v(" (2호선, 7호선 건대입구역 6번출구) ")])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--xxs"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('txt', {
    staticClass: "font-weight-bold txt--dark"
  }, [_vm._v("공급호수")])], 1), _c('v-col', [_c('txt', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" 총 480 세대 중 민간임대 313세대 "), _c('br'), _vm._v(" (특별공급 63세대, 일반공급 250세대) ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "588",
      "src": "/images/sub/application/application.png"
    }
  })], 1)], 1)], 1), _c('application-dialog', {
    ref: "applicationDialog"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }